__turbopack_context__.v({
  "globalHeading": "howItWork-module-scss-module__Aamo8W__globalHeading",
  "howitwork-box-first": "howItWork-module-scss-module__Aamo8W__howitwork-box-first",
  "howitworkBox": "howItWork-module-scss-module__Aamo8W__howitworkBox",
  "howitworkBoxFirst": "howItWork-module-scss-module__Aamo8W__howitworkBoxFirst",
  "loginBox": "howItWork-module-scss-module__Aamo8W__loginBox",
  "seeBtnAction": "howItWork-module-scss-module__Aamo8W__seeBtnAction",
  "step-three": "howItWork-module-scss-module__Aamo8W__step-three",
  "stepBidBox": "howItWork-module-scss-module__Aamo8W__stepBidBox",
  "stepBidInner": "howItWork-module-scss-module__Aamo8W__stepBidInner",
  "stepBidTxt": "howItWork-module-scss-module__Aamo8W__stepBidTxt",
  "stepNumber": "howItWork-module-scss-module__Aamo8W__stepNumber",
  "stepOne": "howItWork-module-scss-module__Aamo8W__stepOne",
  "stepText": "howItWork-module-scss-module__Aamo8W__stepText",
  "stepThree": "howItWork-module-scss-module__Aamo8W__stepThree",
  "stepTwo": "howItWork-module-scss-module__Aamo8W__stepTwo",
  "wonTxt": "howItWork-module-scss-module__Aamo8W__wonTxt",
});
